export const LAST_CREATED_OBJECT_ID = 'last_created_object_id';
